import { useMemo } from 'react';
import useSWR from "swr";
import { useAuthenticatedUser } from "../AuthProvider";
import { swrKey, userFetcher } from "components/userApi";

export function useUserPermissions() {
  const user = useAuthenticatedUser();
  const { data, isLoading, error } = useSWR(swrKey, userFetcher);

  const baseConditions = useMemo(() => {
    if (isLoading) return { canShowAny: false };
    if (error) return { canShowAny: false };
    if (!data) return { canShowAny: false };

    return {
      canShowAny: true,
      isDetailRegistered: data.isDetailRegistered,
      isApproved: data.isApproved,
      emailVerified: user.emailVerified,
    };
  }, [data, isLoading, error, user.emailVerified]);

  return {
    ...baseConditions,
    isShowInfoChangeReq: baseConditions.canShowAny
      && baseConditions.emailVerified
      && baseConditions.isDetailRegistered
      && baseConditions.isApproved,
    isShowDetailRegister: baseConditions.canShowAny
      && baseConditions.emailVerified
      && !baseConditions.isDetailRegistered,
    isShowFactoringEntry: baseConditions.canShowAny
      && baseConditions.emailVerified
      && baseConditions.isDetailRegistered
      && baseConditions.isApproved,
    isShowEmailVerificationOnly: baseConditions.canShowAny
      && !baseConditions.emailVerified,
    isRegisteredButNotApproved: baseConditions.canShowAny
      && baseConditions.emailVerified
      && baseConditions.isDetailRegistered
      && !baseConditions.isApproved,
  };
}
